import isNumber from 'lodash/isNumber';
import isFunction from 'lodash/isFunction';


export default { // type script crutch substitute
  notUndefined(value) {
    if (value === undefined) {
      throw new Error('value must be defined!');
    }

    return value;
  },
  number(value) {
    this.notUndefined(value);

    if (!isNumber(value)) {
      throw new Error('`' + value + '` must be number');
    }

    return value;
  },

  func(value) {
    this.notUndefined(value);

    if (!isFunction(value)) {
      throw new Error('`' + value + '` must be function');
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/assert/index.js